<template>
  <li class="nav-item">
    <div class="step-content">
      {{ step }}
      <img
        class="float-right"
        src="@/assets/images/Icon awesome-exclamation-triangle.png"
        width="18"
        height="18"
        v-if="error"
      />
      <img
        class="float-right"
        src="@/assets/images/Icon awesome-check-circle.png"
        width="18"
        height="18"
        v-else-if="done"
      />
    </div>
    <div class="title-content">{{ title }}</div>
    <div class="error-content" v-if="error">{{ error }}</div>
    <div class="body-content" v-else>{{ body }} {{ value }}</div>
  </li>
</template>

<script>
export default {
  props: {
    step: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    body: {
      type: String,
      default: '',
    },
    error: {
      type: String,
      default: '',
    },
    value: {
      type: Number,
      default: 0,
    },
    done: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.step-content {
  margin-bottom: 10px;
}
.title-content {
  font-size: 12px;
  margin-left: 20px;
  margin-right: 10px;
  margin-bottom: 10px;
}
.body-content {
  margin-left: 20px;
  margin-bottom: 20px;
}
.error-content {
  color: red;
  font-size: 12px;
  margin-left: 20px;
  margin-right: 10px;
  margin-bottom: 10px;
}
</style>
